import './Place.scss';
import { useEffect, useState } from 'react';
import { ReactComponent as LogoIcon } from '../assets/bi.svg';
import { statusClass } from '../utils/Utils';

function Place({ place, user }) {
  const [status, setStatus] = useState('--nologin');

  useEffect(() => {
    if (user.vaccine) {
      setStatus(statusClass(user.vaccine.vaccine_status));
    }
  }, [user]);

  return (
    <div className="place bg-white shadow">
      <div className="container max-w-screen-lg mx-auto">
        <div className="flex justify-start my-1">
          <div className="flex-none flex justify-center p-2">
            <LogoIcon className={'logo ' + status} />
          </div>
          <div className="flex-grow flex flex-col justify-start text-left p-2">
            <h2 className="font-bold text-2xl">เช็คอิน{place.display}</h2>
            <h3 className="font-medium text-xl">มหาวิทยาลัยราชภัฏสกลนคร</h3>
            {
              user.profile && (
                <div className="user font-base">
                  <div className="flex justify-between">
                    <div className="font-bold">ชื่อสกุล </div>
                    <div>
                      {user.profile.display}
                    </div>
                  </div>
                  <div className="flex justify-between">
                    <div className="font-bold">ประเภท</div>
                    <div>{user.profile.agency}</div>
                  </div>
                </div>
              )
            }
          </div>
        </div>
      </div>
    </div>
  );
}

export default Place;
